// Reduxを操作する際に必要ななる関数
import axios from 'axios';
import React from "react";

/***************************************************/
// 定数
/***************************************************/
export const GET_METHOD = 'get';              // GETメソッド
export const POST_METHOD = 'post';            // POSTメソッド
export const PATCH_METHOD = 'patch';          // PATCHメソッド
export const DELETE_METHOD = 'delete';        // DELETEメソッド
export const REQUEST_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD: 400,
  NOT_FOUND: 404,
  REQUEST_TIMEOUT: 408,
  SERVER_ERROR: 500,
  UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
}

/***************************************************/
//機能：GMOトークン発行のエラーメッセージ
//引数：
//戻り：
/***************************************************/
export const gmoErrorMsg = code => {
  switch(code) {
    case 100:
      window.alert("カード番号が入力されていません");
      break;
    case 101:
      window.alert("カード番号に数字以外の文字が含まれています");
      break;
    case 102:
      window.alert("カード番号の桁数が誤っています");
      break;
    case 110:
      window.alert("有効期限が入力されていません");
      break;
    case 111:
      window.alert("有効期限に数字以外の文字が含まれています");
      break;
    case 112:
      window.alert("有効期限の桁数が誤っています");
      break;
    case 113:
      window.alert("有効期限の月情報が誤っています");
      break;
    case 121:
      window.alert("セキュリティコードに数字以外の文字が含まれています");
      break;
    case 122:
      window.alert("セキュリティコードの桁数が誤っています");
      break;
    case 131:
      window.alert("名義人に使用できない文字が含まれています");
      break;
    case 132:
      window.alert("名義人の入力文字数が多すぎます");
      break;
    default:
      window.alert("購入処理中にエラーが発生しました(エラーコード: " + code + ")");
      break;
  }
  throw 'credit card error';
}


/***************************************************/
//機能：
//引数：
//戻り：
/***************************************************/
export const switchSnack = (statusCode) => {
  switch(statusCode) {
    case REQUEST_STATUS.BAD:
      return openBar('予期せぬエラーが発生しました', 'error');
    case REQUEST_STATUS.NOT_FOUND:
      return openBar('URLが誤っています', 'error');
    case REQUEST_STATUS.REQUEST_TIMEOUT:
      return openBar('リクエストがタイムアウトしました', 'error');
    case REQUEST_STATUS.SERVER_ERROR:
      return openBar('サーバエラーが発生しました', 'error');
    case REQUEST_STATUS.UNAVAILABLE:
      return openBar('現在アクセスが集中しています', 'error');
    case REQUEST_STATUS.GATEWAY_TIMEOUT:
      return openBar('ネットワークの中継でタイムアウトしました', 'error');
  }
}

/***************************************************/
//機能：API通信（同期処理）
//引数：（String）url, （String）method, （Object）params
//戻り：（Object）Promise
/***************************************************/
export const promiseCallApi = (url, method, params = null) => {
  let response = null;
  try {
    if(method == 'get') {
      !params ? response = axios.get(url) : response = axios.get(url, { params: params });
    }
    else if (method == 'post') {
      !params ? response = axios.post(url) : response = axios.post(url, params);
    }
    else if (method == 'delete') {
      !params ? response = axios.delete(url) : response = axios.delete(url, { params: params });
    }
    else {
      !params ? response = axios.patch(url) : response = axios.patch(url, params);
    }
  }
  catch(error) {
  }
  return new Promise(resolve => {
    resolve(response);
  });
}

/***************************************************/
//機能：スリープ（指定時間一時停止）
//引数：（int）停止させる時間
//戻り：（Object）promise
/***************************************************/
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/***************************************************/
//機能：郵便番号より住所情報を取得
//引数：（int）停止させる時間
//戻り：（Object）promise
/***************************************************/
export const searchAddress = async(zip_code) => {
  const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/addresses/search_address.json`
  const params = { zipcode: zip_code };
  const response = await promiseCallApi(url, GET_METHOD, params);
  if(response.status === REQUEST_STATUS.OK) {
    // 成功
    const result = response.data.result
    return result
  }
};

/***************************************************/
//機能：商品コードを該当商品画像のパスに変換する
//引数：string, array
//戻り：string or array
/***************************************************/
export const convertItemImagePath = (stock_code, options = 'p') => {
  const r_stock_code = stock_code.split("").reverse().join("");
  const domain = `${process.env.NEXT_PUBLIC_ITEM_IMAGE_BUCKET_URL}`
  let image_paths = []
  const options_array = [options]
  options_array.flat().map((option) => {
    image_paths.push(`${domain}/${r_stock_code.slice(-3)}/f${r_stock_code}-${option}.jpg`)
  })
  return image_paths.length === 1 ? image_paths.toString() : image_paths
}

/***************************************************/
//機能：S3にある画像パスを返す
//引数：string, array
//戻り：string or array
/***************************************************/
export const convertImagePath = (url) => {
  const domain = `${process.env.NEXT_PUBLIC_IMAGE_BUCKET_URL}`
  return `${domain}/${url}`
}

/***************************************************/
//機能：日時を日本時間に変換する
//引数：string
//戻り：date
/***************************************************/
export const localeTimeToJST = (string) => {
  const JST = -540
  const base_datetime = new Date(string)
  base_datetime.setTime(base_datetime.getTime() - JST)
  return base_datetime
}


/***************************************************/
//機能：日付のフォーマット変換
//引数：（Date）日付,（String）日付フォーマット
//戻り：（String）フォーマット変換後の日付文字列
/***************************************************/
export const renderDate = (date, format) => {

  const weekDay = ['日', '月', '火', '水', '木', '金', '土'];

  if (!format) {
    format = 'YYYY年-M月-D日（d） -h時mm分ss秒';
  }
  if(date) {
    if(format.includes('YYYY')) format = format.replace(/YYYY/g, date.getFullYear());
    if(format.includes('MM'))   format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    if(format.includes('-M'))   format = format.replace(/-M/g, (date.getMonth() + 1));
    if(format.includes('DD'))   format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    if(format.includes('-D'))   format = format.replace(/-D/g, date.getDate());
    if(format.includes('d'))    format = format.replace(/d/g, weekDay[date.getDay()]);
    if(format.includes('hh'))   format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    if(format.includes('-h'))   format = format.replace(/-h/g, date.getHours());
    if(format.includes('mm'))   format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    if(format.includes('-m'))   format = format.replace(/-m/g, date.getMinutes());
    if(format.includes('ss'))   format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if(format.includes('-s'))   format = format.replace(/-s/g, date.getSeconds());
    return format;
  }
  else {
    return null;
  }
}

/***************************************************/
//機能：文字のバイト数計算（SJIS）
//引数：（String）文字
//戻り：（Number）数値
/***************************************************/
export const stringBytes = (str) => {
  let length = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1;
    } else {
      length += 2;
    }
  }
  return length;
}

/***************************************************/
//機能：16進数の色コードを10進数に変換する
//引数：（String）6桁の16進数 （例:#FFFFFF）
//戻り：（Array）配列　（例:[255,255,255]）
/***************************************************/
export const convertRGB = (str) => {
  const hexCode = str.replace('#','')
  const cutLength = hexCode.length === 6 ? 2 : 1
  let rgb = new Array(3)
  rgb[0] = parseInt(hexCode.substr(0,cutLength), 16)
  rgb[1] = parseInt(hexCode.substr(cutLength * 1,cutLength), 16)
  rgb[2] = parseInt(hexCode.substr(cutLength * 2,cutLength), 16)

  return rgb
}
